import FetchFactory from "vuex-fetch-factory";
import { StateInterface } from "./state";
import {
  InvoiceRaw,
  InvoiceModel,
  AccessLogUserModel,
  AccessLogUserRaw
} from "../models";
import { getInvoicesForCurrentUser, getAccessLogs } from "../api";
import { setInvoicesHandle, setAccessLogsHandle } from "./mutations";

const factory = new FetchFactory<StateInterface, {}>();

export default {
  fetchInvoices: factory.createBulkFetcher<{}, InvoiceRaw, InvoiceModel>(
    true,
    setInvoicesHandle,
    getInvoicesForCurrentUser,
    (): InvoiceModel => new InvoiceModel()
  ),
  fetchAccessLogs: factory.createBulkFetcher<
    {},
    AccessLogUserRaw,
    AccessLogUserModel
  >(
    true,
    setAccessLogsHandle,
    getAccessLogs,
    (): AccessLogUserModel => new AccessLogUserModel()
  )
};
